// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccommodationsRouteImport } from './routes/accommodations'
import { Route as AmenitiesRouteImport } from './routes/amenities'
import { Route as AuburnRvMapRouteImport } from './routes/auburn-rv-map'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as NearbyAttractionsRouteImport } from './routes/nearby-attractions'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as ReservationsRouteImport } from './routes/reservations'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccommodationsRoute = AccommodationsRouteImport.update({
            id: '/accommodations',path: '/accommodations',getParentRoute: () => rootRouteImport
          })
const AmenitiesRoute = AmenitiesRouteImport.update({
            id: '/amenities',path: '/amenities',getParentRoute: () => rootRouteImport
          })
const AuburnRvMapRoute = AuburnRvMapRouteImport.update({
            id: '/auburn-rv-map',path: '/auburn-rv-map',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const NearbyAttractionsRoute = NearbyAttractionsRouteImport.update({
            id: '/nearby-attractions',path: '/nearby-attractions',getParentRoute: () => rootRouteImport
          })
const RatesRoute = RatesRouteImport.update({
            id: '/rates',path: '/rates',getParentRoute: () => rootRouteImport
          })
const ReservationsRoute = ReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccommodationsRoute: AccommodationsRoute,AmenitiesRoute: AmenitiesRoute,AuburnRvMapRoute: AuburnRvMapRoute,ContactUsRoute: ContactUsRoute,NearbyAttractionsRoute: NearbyAttractionsRoute,RatesRoute: RatesRoute,ReservationsRoute: ReservationsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)